import React from "react";
import Spinner from "../../../Spinner";
import * as sharedStyled from "../../styled";
import logo from "../../../../resources/bluedot-logo.png";
import * as styled from "./styled";

export default () => {
  return (
    <sharedStyled.Container>
      <div>
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <styled.SpinnerWrapper>
            <Spinner />
          </styled.SpinnerWrapper>
          <h3>Please wait ..</h3>
        </sharedStyled.MainContentContainer>
      </div>
    </sharedStyled.Container>
  );
};
